export const SET_SMART_REMINDERS = 'SET_SMART_REMINDERS';
export const ADD_SMART_REMINDER = 'ADD_SMART_REMINDER';
export const UPDATE_SMART_REMINDER = 'UPDATE_SMART_REMINDER';
export const DELETE_SMART_REMINDERS = 'DELETE_SMART_REMINDERS';
export const GET_SMART_REMINDER_TEMPLATE = 'GET_SMART_REMINDER_TEMPLATE';
export const SMART_REMINDERS_RUN_NOW = 'SMART_REMINDERS_RUN_NOW';
export const DELETE_SMART_REMINDER = 'DELETE_SMART_REMINDER';
